<template>
  <v-app>
    <v-dialog v-model="bookingEditDialog" scrollable max-width="640px" persistent :fullscreen="fullscreen">
      <app-bookingEdit
        :companyId="companyId"
        :activeBranch="activeBranch"
        :salonhubname="salonhubname"
        :lang="lang"
        :stepperHeight="stepperHeight"
        :gender="gender"
        :clientIntel="clientIntel"
        :clientOrder="clientOrder"
        :treatmentByParam="treatmentByParam"
        :treatmentByParamName="treatmentByParamName"
        :treatmentByParamPrice="treatmentByParamPrice"
        :skipTreatmentSelectById="skipTreatmentSelectById"
        :skipEmployeeSelectById="skipEmployeeSelectById"
        :clientName="clientName"
        :clientEmail="clientEmail"
        :clientTel="clientTel"
        :showPrice="showPrice"
        :startUrl="startUrl"
        :src="src"
        :url="url"
        :multipleTreatmentsByParam="multipleTreatmentsByParam"
        :executedFrom="executedFrom"
        :succesUrl="succesUrl"
        :clientExist="clientExist"
        :userAgent="userAgent"
        :stepperCardHeight="stepperCardHeight"
        :salonname="salonname"
        :salonhubApiSettings="salonhubApiSettings"
        :callcenter="callcenter"
        :callTo="callTo"
        :policy="policy"
        :debug="debug"
        :smsSettings="smsSettings"
        :treatments="treatments"
        :confirmMail="confirmMail"
        :feedBackOnClose="feedBackOnClose"
        :showCallback="showCallback"    
        :extraTermsUrl="extraTermsUrl"
        @BookingEditChange="bookingEditDialog = $event"
      ></app-bookingEdit>
    </v-dialog>

    <survey
      v-if="surveyData"
      :companyId="companyId"
      :survey="surveyData"
      :test="surveyTest"
      :userAgent="userAgent"
      :source="src"
      :language="lang"
      :calculatorCountry="calculatorCountry"
      :questionsStart="questionsStart"
    >
    </survey>

  </v-app>
</template>




<script>
window.__lo_site_id = 321259;
  (function() {
    var wa = document.createElement('script'); wa.type = 'text/javascript'; wa.async = true;
    wa.src = 'https://d10lpsik1i8c69.cloudfront.net/w.js';
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(wa, s);
  })();

import bookingEdit from "./components/bookingEdit";
import survey from "./components/survey";
import { auth } from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import db from "./firebase/init";
import axios from "axios";
import moment from "moment";
import { bus } from "./main";


export default {
  name: "widget",
  // props: ["companyId", "activeBranch"], // Company, Passthru activeBranch router
  components: {
    "app-bookingEdit": bookingEdit,
    "survey": survey,
  },

  data: () => ({
    configAxios: {
      headers: { Authorization: `Bearer b3b9dbb9-249a-4aac-9a94-5809beedcb1d` }
    },
    bookingEditDialog: false,
    fullscreen: true,
    companyId: null,

    activeBranch: null,
    lang: "NL",
    salonhubname: null,
    calculatorCountry: 'nl',
    gender: "female",
    clientIntel: "front",
    clientOrder: null,
    multipleTreatmentsByParam: new Array(),
    treatmentByParam: null,
    treatmentByParamName: null,
    treatmentByParamPrice: 0,
    skipTreatmentSelectById:null,
    skipEmployeeSelectById: null,
    treatments: {},
    clientName: "",
    clientEmail: "",
    clientTel: "",
    showPrice: true,
    clientExist: false,
    userAgent: "",
    salonhubApiSettings: "",
    src: "",
    executedFrom: "",
    url: "url", //Salon
    succesUrl: "",
    startUrl: null,
    salonname: "", //name salon
    policy: {}, //Policy companie
    callcenter: {},
    confirmMail: false,
    callOrder: [],
    callTo: null,
    feedBackOnClose: false,
    showCallback: false,
    smsSettings: {},
    // callUrl: "",
    windowWidth: 0,
    windowHeight: 0,
    stepperHeight: "0px",
    stepperCardHeight: "0px",
    debug: false,
    startStamp: null,
    surveyData: null,
    surveyTest: false,
    questionsStart: false,
    extraTermsUrl: null,
  }),

  
  created() {
    this.startStamp = moment().format("YYYY-MM-DD HH:mm:ss:SSS")
    if(
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.userAgent = "mobile";
    } else {
      this.userAgent = "desktop";
    }
   
    this.$nextTick(()=> {
      window.addEventListener("resize", ()=>{
        setTimeout(()=> {
          this.getWindowHeight();
          this.getWindowWidth();
        }, 50);
      });

      //Init
      this.getWindowWidth();
      this.getWindowHeight();

      if (this.windowWidth <= 640) {
        this.fullscreen = true;
      } else {
        this.fullscreen = false;
      }
    });

    this.companyId = this.$route.query.companyId;
    this.activeBranch = this.$route.query.activeBranch;
    // this.salonhubname = this.$route.query.sh;
    if(this.$route.query.lang){
      console.log("Lang gevonden: ", this.$route.query.lang)
      this.lang = this.$route.query.lang;
    }
    
    if(this.$route.query.gender){
      this.gender = this.$route.query.gender;
    }

    if(this.$route.query.cls){
      this.surveyData = this.$route.query.cls;
      // console.log("bus exacted")
      // bus.$emit('getSurvey', this.$route.query.survey);
    }
    if(this.$route.query.clst && this.$route.query.clst == 'hogans'){
      this.surveyTest = true;
    }

    if(this.$route.query.qst && this.$route.query.qst == '1'){
      this.questionsStart = true;
    }

    if(this.$route.query.exsrc){
      this.executedFrom = this.$route.query.exsrc;
    }
    
    if(this.$route.query.ci){
      this.clientIntel = this.$route.query.ci;
    }
    
    if(this.$route.query.cio){
      this.clientOrder = this.$route.query.cio;
    }

    if(this.$route.query.ftm){ // Filtered Treatments (Array as Param)
      this.multipleTreatmentsByParam = (this.$route.query.ftm).split(",");
    }
    
    if(this.$route.query.shtm){
      this.treatmentByParam = Number(this.$route.query.shtm);
    }

    if(this.$route.query.shtmn){
      this.treatmentByParamName = this.$route.query.shtmn;
    }

    if(this.$route.query.shtmp){
      this.treatmentByParamPrice = Number(this.$route.query.shtmp);
    }

    if(this.$route.query.stsbi){ // Skip Treatment Select By Id
      this.skipTreatmentSelectById = this.$route.query.stsbi;
    }

    if(this.$route.query.sesbi){ // Skip Employee Select By Id
      this.skipEmployeeSelectById = this.$route.query.sesbi;
    }
    
    if(this.$route.query.shname){
       this.clientName = this.$route.query.shname;
    }
    if(this.$route.query.cc){
       this.calculatorCountry = this.$route.query.cc;
    }

    if(this.$route.query.shem){
      this.clientEmail = this.$route.query.shem;
    }
    
    if(this.$route.query.shtel){
      this.clientTel = this.$route.query.shtel;
    }
    
    if(this.$route.query.shp){
      this.showPrice = Number(this.$route.query.shp) == 1 ? true : false;
    }

    if(this.$route.query.surl){
      this.startUrl = this.$route.query.surl;
    }

    if(this.$route.query.hdb && this.$route.query.hdb == 'utrechtbuigtnooit'){
      this.debug = true;
    }

    

    let checkSource = this.$route.query.src;

    //Check if array
    if (typeof checkSource !== "undefined") {
      if (Array.isArray(checkSource)) {
        this.src = checkSource[0];
      } else {
        this.src = checkSource;
      }
    } 
    else {
      this.src = "notInstalled";
    }

   

    if(!this.surveyData){
      this.getSalonhubSettings();
    }
      
  
    

    // window.addEventListener("orientationchange", (event)=> {
    //   console.log("the orientation of the device is now " + event.target.screen.orientation.angle);
    //   console.log("orientationchange windowWidth: ", this.windowWidth)
    //   console.log("orientationchange windowHeight: ", this.windowHeight)
    //   this.getWindowWidth();
    //   this.getWindowHeight();
      
    // });
  },

  methods: {
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
    },

    getWindowHeight() {
      this.windowHeight = document.documentElement.clientHeight;
    },

    getSalonhubSettings() {
      let start = moment(moment().format("YYYY-MM-DD HH:mm:ss:SSS"),"YYYY-MM-DD HH:mm:ss:SSS").diff(moment(this.startStamp,"YYYY-MM-DD HH:mm:ss:SSS"), 'milliseconds');
      console.log("getSalonhubSettings", start)
      let salonhubApiSettings = {
        md5: "",
        salons: "",
        customer: "",
        username: "",
        url: ""
      };

      db.collection("companies")
        .doc(this.companyId)
        .get()
        .then(doc => {
          if (doc.exists) {
            salonhubApiSettings.md5 = doc.data().salonhubApiSettings.md5;
            salonhubApiSettings.customer = doc.data().salonhubApiSettings.customer;
            this.salonhubname = doc.data().salonhubApiSettings.customer;
            salonhubApiSettings.salons = doc.data().salonhubApiSettings.salons;
            salonhubApiSettings.username = doc.data().salonhubApiSettings.username;
            this.url = doc.data().url;
            this.succesUrl = doc.data().conversion.salonhubSettings.succesUrl;
            this.salonhubApiSettings = salonhubApiSettings;
            this.callcenter = doc.data().conversion.callcenter;
            if(doc.data().conversion.feedBackOnClose){
              this.feedBackOnClose = doc.data().conversion.feedBackOnClose;
            }
            if(doc.data().conversion.showCallback){
              this.showCallback = doc.data().conversion.showCallback;
            }
            if(doc.data().conversion.smsSettings){
              this.smsSettings = doc.data().conversion.smsSettings;
              this.smsSettings.name = doc.data().name;
              this.smsSettings.compId = doc.id;
            }

            if(doc.data().conversion.termsUrl){
              this.extraTermsUrl = doc.data().conversion.termsUrl;
            }
            
            // this.callUrl = doc.data().conversion.salonhubSettings.callUrl;
            this.policy = doc.data().conversion.salonhubSettings.policy;
            this.confirmMail = doc.data().conversion.salonhubSettings.enableConfirmationEmail;

            //Get salonname by Id
            for (
              let index = 0;
              index < salonhubApiSettings.salons.length;
              index++
            ) {
              // console.log(salonhubApiSettings.salons[index]);
              if (
                salonhubApiSettings.salons[index].salonhubid ==
                this.activeBranch
              ) {
                this.salonname = salonhubApiSettings.salons[index].name;
                break;
              }
            }
            let time = moment(moment().format("YYYY-MM-DD HH:mm:ss:SSS"),"YYYY-MM-DD HH:mm:ss:SSS").diff(moment(this.startStamp,"YYYY-MM-DD HH:mm:ss:SSS"), 'milliseconds');
            console.log("bookingEditDialog true", time)
            this.bookingEditDialog = true;
          } else {
            // doc.data() will be undefined in this case
            console.log("Company not found");
          }
        })
        .then(() => {
          
          this.callOrder = new Array();

          // this.callcenter.callModule = false;

          if (this.callcenter.callModule == true) {
            if (this.callcenter.hogansFirst == true) {
              this.callOrder = ["hogans", this.companyId];
              this.chooseToCall();
            }
            else {
              this.callOrder = [this.companyId, "hogans"];
              this.chooseToCall();
            }
          }
        })
        .catch(error => {
          console.log("Error getting document:", error);
        });
    },

    async chooseToCall() {
      let HumansAvailable = {
        hogans: null, //Fixed nummer
        [this.companyId]: null //Fixed Number for companies
      };

      await db
        .collection("users")
        .where("callActive", "==", true)
        .where("callCompanies", "array-contains", this.companyId)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());

            //Will Hogans take care for VOIP
            if (doc.data().hogansCaller == true) {
              // Filter only who can call
              // console.log("hogansCaller true");
              HumansAvailable.hogans = doc.data().callTo[this.companyId];
              // if (typeof doc.data().callTo[this.companyId] != "undefined") {
              //   hogansHumansAvailable = doc.data().callTo[this.companyId];
              // }
            } else {
              HumansAvailable[this.companyId] = doc.data().callTo;
            }
          });
        })
        .catch(error => {
          console.log("Error getting documents: ", error);
        });

      // console.log("HumansAvailable", HumansAvailable);

      if (HumansAvailable.hogans == null && HumansAvailable[this.companyId] == null) {
        this.callTo = null;
      }
      else {
        //Selecting by Call Order, found and break
        // console.log("HumansAvailable: ", HumansAvailable)
        for (let index = 0; index < this.callOrder.length; index++) {
          if (HumansAvailable[this.callOrder[index]].length !== null) {
            this.callTo = HumansAvailable[this.callOrder[index]];
            console.log(this.callTo);
            break;
          }
        }
      }
    },

    isStoredLocally(key) {
      let val = localStorage.getItem(key);
      return val === null ? false : true;
    },

    removeFromStorage(keys) {
      for (let key in keys) {
        localStorage.removeItem(key);
      }
    },

    isDateWithin(totaldays, savedDate) {
      let userDate = new Date(savedDate * 1000);
      let maximalDate = new Date(
        new Date().setDate(new Date().getDate() - totaldays)
      );
      return userDate.getTime() > maximalDate.getTime() ? true : false;
    }
  },
  watch: {
    windowWidth() {
      if (this.windowWidth <= 680) {
        this.fullscreen = true;
        this.stepperHeight = this.windowHeight - 230 + "px";
        this.stepperCardHeight = this.windowHeight - 130 + "px";
      } else {
        this.fullscreen = false;
        this.stepperHeight = this.windowHeight - 330 + "px";
        this.stepperCardHeight = this.windowHeight - 250 + "px";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
    window.removeEventListener("resize", this.getWindowHeight);
  },

  
};
</script>


<style scoped>
.v-application {
  background: none;
  color: rgba(0, 0, 0, 0.87) !important;
}

</style>
<style >
.loading-dots-loader {
    margin: 150px auto 0 auto;
    width: 80px;
    height: 80px;
    background: url("./assets/icons/loading-dots.svg") no-repeat center center;
    background-size: 80px auto;
  }
</style>